import { toast } from "react-toastify";
import { INewFile } from "../../containers/Document/Document/interfaces";

export const convertFileToBase64 = (newFile: INewFile): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      if (reader.result) {
        const base64String = reader.result.toString();

        const base64Data = base64String.split(",")[1];
        resolve(base64Data);
      } else {
        reject(new Error("File could not be read"));
      }
    };

    reader.onerror = () => {
      reject(new Error("Error reading file"));
    };

    reader.readAsDataURL(newFile.file);
  });
};

export const convertBase64ToBlob = (base64Data: string, contentType: string = ""): Blob | undefined => {
  try {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  } catch (error) {
    console.log("error: ", error);

    toast("Error parsing file");
  }
};

export const convertBlobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      if (reader.result) {
        const base64String = reader.result.toString();

        const base64Data = base64String.split(",")[1];
        resolve(base64Data);
      } else {
        reject(new Error("File could not be read"));
      }
    };

    reader.onerror = () => {
      reject(new Error("Error reading file"));
    };

    reader.readAsDataURL(blob);
  });
};
